// A committed frontend lifetime, not server authorization. Callers resolve the
// token through their existing auth adapter; credentials are never persisted.
export const nextSportsnewSessionOwner = (previous, {
  userId = null, authToken = '', authenticated = false,
} = {}) => {
  const identity = {
    userId: userId == null ? null : String(userId),
    authToken: typeof authToken === 'string' ? authToken : '',
    authenticated: authenticated === true,
  };
  if (previous && previous.userId === identity.userId
    && previous.authToken === identity.authToken
    && previous.authenticated === identity.authenticated) return previous;
  return Object.freeze({ ...identity, generation: previous ? previous.generation + 1 : 0 });
};
